<template>
  <div v-if="loading" class="comments">

    <div class="comments__header" v-if="this.$store.getters.getPermissions.createComments === true">
      <span
        class="btn-success btn btn-success text-center"
        @click.prevent="add_comment()"
      >
        {{ translate('comments.to_add') }}
      </span>
    </div>

    <div
      v-for="(comment, key) in comments"
      class="comment-item"
      :key="key"
    >
      <div class="comment-card">

        <div class="comment-card_header">
          <span class="comment-card_header_name">

            <span
              v-if="comment.visibility_only_owner"
              class="visible mdi mdi-account"
              :title="translate('comments.filter.me')"
            />
            <span
                v-else
                class="visible mdi mdi-account-group"
                :title="translate('comments.filter.god')"
            />

            {{ comment.user_name }}
          </span>
          <span class="comment-card_header_ts">
            {{ get_date(comment.ts) }}
          </span>
        </div>

        <div class="comment-card_content">
          {{comment.text}}
          <span
              v-if="comment.owner && permissions.editComments === true"
              @click="edit_comment(comment)"
              class="mdi mdi-pen edit"
          />
        </div>
      </div>

    </div>
  </div>

  <div v-else style="height: 100%" >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>

</template>

<script>

import NewComment from "./Comments/NewComment.vue"
import EditComment from "./Comments/EditComment.vue"

export default {
  name: 'Comments',
  props: [
    'params',
  ],
  data () {
    return {
      loading: false,
      comments: []
    }
  },

  computed:{
    permissions() {
      return this.$store.getters.getPermissions
    }
  },

  watch:{
    params(){
      clearInterval(this.interval)
      this.get_comments()
    }
  },

  mounted () {
    this.get_comments()
  },

  methods: {
    get_comments(){
      this.$http.v1.getComments(this.params, (response) => {
        this.comments = response.data;
        this.loading = true
      })
    },
    add_comment(){
      let t = this.$createElement(NewComment, {
        props:{
          params: this.params
        },
        on: {
          close: () => { this.$modal.hide('new_comment') },
          update: () => { this.get_comments() }
        }
      })
      let temp = {
        render () { return t }
      }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'new_comment'})
    },
    edit_comment(comment){
      if (this.permissions.editComments === true){
        let t = this.$createElement(EditComment, {
          props:{
            comment
          },
          on: {
            close: () => { this.$modal.hide('edit_comment') },
            update: () => { this.get_comments() }
          }
        })
        let temp = {
          render () { return t }
        }
        this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'edit_comment'})

      }
    },
  },
}

</script>
<style lang='scss' scoped>
.comments{
  &__header{
    text-align: center;
    font-size: 18px;
    line-height: 150%;
    padding: 10px;
  }
  .comment{
    &-item{
      width: 100%;
      padding: 10px;
    }
    &-card{
      border-radius: 10px;
      box-shadow: 0 2px 2px #ccc5b980;
      color: #252422;
      position: relative;
      border: 1px solid #ccc;
      background-color: #f8f8f8;
      font: 300 1.3rem/150% "Roboto", Arial, sans-serif;
      &_header{
        text-transform: uppercase;
        color: #000;
        background: #f4f3ef;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        border-radius: 10px 10px 0 0;
        overflow: hidden;
        &_name{
          display: flex;
          .visible{
            display: block;
            height: 16px;
            width: 16px;
            font-size: 16px;
            color: #333333;
            margin-right: 5px;
          }
        }
      }
      &_content {
        text-align: left;
        padding: 10px 30px 10px 10px;
        background-color: #e2ecdc;
        border-radius: 0 0 10px 10px;
        overflow: hidden;
        position: relative;
        .edit{
          position: absolute;
          width: 20px;
          height: 20px;
          right: 0;
          bottom: calc(50% - 10px);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
